export const INVITE_CLEANER = 'SAGA/INVITE_CLEANER';

export const inviteCleaner = (payload) => {
  return {
    type: INVITE_CLEANER,
    payload,
  };
};
